import { aludraApi } from 'api/axios'
import { t } from 'i18next'
import { documentTypeId } from 'Utils/constants'
import {
  applyOrderPaymentToQuote,
  getRelatedWebSalesOrder,
} from 'Utils/relatedOrderPayment'
import { mdl11Urls } from './mdl11.urls'

export const fetchRelatedOrderPayment = async relatedOrder => {
  try {
    if (!relatedOrder?.DocHeaderId) throw new Error('Missing related order ID')
    const { data } = await aludraApi.post(mdl11Urls.searchSalesDocumentDetail, {
      DocumentTypeId: documentTypeId.ODV,
      DocumentHeaderId: relatedOrder.DocHeaderId,
      DocumentNumber: relatedOrder.DocumentNumber,
      PageNumber: 1,
      PageSize: 1,
    })
    if (!data?.Data || data?.Status?.Code !== 200) {
      throw new Error('Could not load related order')
    }
    return data.Data
  } catch {
    const error = new Error(
      t('PAYMENT_METHOD_SECTION_T.RELATED_ORDER_LOAD_ERROR')
    )
    error.code = 'RELATED_ORDER_PAYMENT_LOAD_ERROR'
    throw error
  }
}

export const syncRelatedOrderPayment = async payload => {
  const relatedOrder = getRelatedWebSalesOrder(payload?.QuoteHeader)
  if (!relatedOrder) return payload
  const order = await fetchRelatedOrderPayment(relatedOrder)
  return {
    ...payload,
    QuoteHeader: applyOrderPaymentToQuote(payload.QuoteHeader, order),
  }
}
